'use strict';

module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/chart.js/src/charts/Chart.Line.js
// module id = 282
// module chunks = 0